import jQuery from "jquery";
import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  EffectFade,
  A11y,
  Thumbs,
  Keyboard,
} from "swiper/modules";

// Breakpoint constants (matching SCSS variable, see src/styles/includes/_variables.scss)
const BREAKPOINT_MD = 768;

const DEFAULT_PAGINATION = {
  el: ".swiper-pagination",
  type: "bullets",
  clickable: true,
};

const NUMBERED_PAGINATION = {
  ...DEFAULT_PAGINATION,
  renderBullet: function (index, className) {
    return '<button class="' + className + '">' + (index + 1) + "</button>";
  },
};

const DEFAULT_NAVIGATION = {
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
};

function createSwiper(element, config = {}) {
  const modules = config.modules || [];

  const existingOn = config.on || {};
  const enhancedOn = {
    ...existingOn,
    init: function (swiper) {
      if (existingOn.init) {
        existingOn.init.call(this);
      }
      updateSwiperA11y(swiper);
    },
    slideChangeTransitionEnd: function (swiper) {
      if (existingOn.slideChange) {
        existingOn.slideChange.call(this);
      }
      updateSwiperA11y(swiper);
    },
  };

  return new Swiper(element, {
    ...config,
    modules: [A11y, ...modules],
    a11y: {
      enabled: true,
      ...config.a11y,
    },
    on: enhancedOn,
  });
}

/**
 * Swiper generic accessibility control function
 * @param {Swiper} swiper - Swiper instance
 *
 * - Hide inactive slides from screen readers.
 * - Disable keyboard focus on inactive slides.
 * - Also applied them to looped sliders.
 */
function updateSwiperA11y(swiper) {
  if (!swiper || !swiper.slides) {
    console.warn("updateSwiperA11y: Invalid Swiper instance");
    return;
  }

  swiper.slides.forEach((slide) => {
    const isVisible =
      slide.classList.contains("swiper-slide-visible") ||
      slide.classList.contains("swiper-slide-active");
    const isDuplicate = slide.classList.contains("swiper-slide-duplicate");

    if (isVisible && !isDuplicate) {
      slide.removeAttribute("aria-hidden");
      slide.removeAttribute("inert");
    } else {
      slide.setAttribute("aria-hidden", "true");
      slide.setAttribute("inert", "");
    }
  });
}

jQuery(function ($) {
  // initialize accordoins
  // initAccordions();

  // init info sliders
  initInfoSliders();

  // init featured recipes slider
  initFeaturedRecipesSlider();

  // init product details slider
  initProductDetailsSlider();

  // init product timeline slider
  initProductTimelineSlider();

  // init banner slider
  initBannerSlider();

  // init specs gallery
  initSpecsGallery();

  // init loadMore button on featured products
  loadMoreFeaturedProducts();

  setupJudgemeReviews();

  // init toaster modes slider
  initToasterModesSlider();
});

document.addEventListener("DOMContentLoaded", () => {
  initVideos();
});

// Initialize Info sliders
function initInfoSliders() {
  $(".info-slider-container").each(function () {
    var textEl = $(this).find(".info-slider--text").get(0);
    var mediaEl = $(this).find(".info-slider--media").get(0);
    var swiperText, swiperMedia;
    swiperText = createSwiper(textEl, {
      modules: [Pagination, EffectFade],
      effect: "fade",
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      pagination: NUMBERED_PAGINATION,
      on: {
        init: function (swiper) {
          this.el.classList.add(`current-index-${this.realIndex}`);
        },
        slideChange: function (swiper) {
          this.el.className = this.el.className.replace(
            /\bcurrent-index.*?\b/g,
            ""
          );
          this.el.classList.add(`current-index-${this.realIndex}`);
          if (swiperMedia !== undefined) {
            swiperMedia.slideTo(this.realIndex);
          }
        },
      },
    });
    swiperMedia = createSwiper(mediaEl, {
      modules: [Pagination],
      pagination: NUMBERED_PAGINATION,
      on: {
        slideChange: function (swiper) {
          if (swiperText !== undefined) {
            swiperText.slideTo(this.realIndex);
          }
        },
      },
    });

    // To fix sliders which are not properly initialized when hidden
    window.addEventListener("JBupdateInfoSliders", () => {
      if (swiperText) swiperText.update();
      if (swiperMedia) swiperMedia.update();
    });
  });

  $(".slide--read-more").on("click", function (e) {
    e.preventDefault();
    $(this)
      .closest(".swiper-wrapper")
      .css({ height: "auto" })
      .toggleClass("expanded-text");
  });
}

// Initialize videos with poster images
function initVideos() {
  const videos = document.querySelectorAll(".js-video-with-poster");

  videos.forEach((video) => {
    // Handle video play/pause on click
    video.addEventListener("click", (e) => {
      e.preventDefault();
      if (!video.hasAttribute("controls")) {
        video.setAttribute("controls", "controls");
      }
      if (video.paused || video.ended) {
        video.play().catch((error) => {
          console.error("Video playback failed:", error);
        });
      } else {
        video.pause();
      }
    });

    // Handle when the video ends
    video.addEventListener("ended", (e) => {
      video.pause(); // Ensure the video is paused
      video.currentTime = 0; // Reset video to the start
      video.removeAttribute("controls"); // Remove controls if necessary
      // Force reload the poster by reloading the video
      video.load();
    });
  });
}

// Initialize accordions
function initAccordions() {
  $(".js-accordion-item").each(function (index, item) {
    $(item)
      .find(".accordion-item--title")
      .on("click", function () {
        $(this).toggleClass("is-active");
        $(this).siblings(".accordion-item--description").slideToggle();
      });
  });
}

// Initialize featured recipes slider
function initFeaturedRecipesSlider() {
  $(".featured-recipes--swiper").each(function (index, item) {
    var recipesSwiper = createSwiper(item, {
      modules: [Navigation],
      spaceBetween: 12,
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      breakpoints: {
        [BREAKPOINT_MD]: {
          slidesPerView: 3,
        },
      },
      navigation: DEFAULT_NAVIGATION,
    });
  });
}

// Initialize product details slider on collection page
function initProductDetailsSlider() {
  $(".product-details--grid").each(function (index, item) {
    var sliderEl = $(item).find(".product-details--media-swiper").get(0);

    var productSlider = createSwiper(sliderEl, {
      modules: [Navigation, Pagination],
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
        // dynamicBullets: true,
        // dynamicMainBullets: 8,
      },
      navigation: DEFAULT_NAVIGATION,
    });

    $(item)
      .find(".color-radio")
      .on("change", function (index, item) {
        var color = $('input[name="color"]:checked').val();

        var slideIndex = $(sliderEl)
          .find(`.swiper-slide[data-image-color=${color}]`)
          .index();
        productSlider.slideTo(slideIndex);
      });
  });
}

// Initialize product timeline slider
function initProductTimelineSlider() {
  $(".pt--slider").each(function (index, item) {
    var productTimelineSlider = createSwiper(item, {
      modules: [Navigation],
      slidesPerView: "auto",
      // centeredSlides: true,
      // loop: true,
      loopAdditionalSlides: 3,
      breakpoints: {
        [BREAKPOINT_MD]: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
      },
      navigation: DEFAULT_NAVIGATION,
    });
  });
}

// Initialize banner slider
function initBannerSlider() {
  $(".banner-slider-container").each(function (index, item) {
    var sliderEl = $(item).find(".banner-slider-swiper").get(0);

    var options = {
      modules: [EffectFade],
      fadeEffect: {
        crossFade: true,
      },
      effect: "fade",
      speed: 800,
      loop: true,
      autoHeight: true,
    };

    if ($(sliderEl).hasClass("has-pagination")) {
      options.pagination = DEFAULT_PAGINATION;
      options.modules.push(Pagination);
    }
    if ($(sliderEl).hasClass("has-navigation")) {
      options.navigation = DEFAULT_NAVIGATION;
      options.modules.push(Navigation);
    }
    var bannerSlider = createSwiper(sliderEl, options);
  });
}

function setupJudgemeReviews() {
  if ($("#judgeme_product_reviews").length > 0) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          if ($(mutation.target).hasClass("jdgm--done-setup-widget")) {
            let text = $(".jdgm-rev-widg__summary-average").text().trim();
            let firstWord = text.split(" ")[0];
            $(".jdgm-rev-widg__summary-average").text(firstWord);
            observer.disconnect();
          }
        }
      });
    });

    observer.observe(document.getElementById("judgeme_product_reviews"), {
      attributes: true,
    });
  }
}

function initSpecsGallery() {
  /* sync slide and thumbnail. Those sliders require a high level of accessibility compliance. */
  const mainSlides = document.querySelectorAll(
    ".p-color-variation-swiper__slide"
  );
  const slideInfo = Array.from(mainSlides).map((slide, index) => {
    const slideId =
      slide.getAttribute("id") ||
      `p-color-variation-swiper__slide-${index + 1}`;
    return {
      slideId: slideId,
    };
  });

  const thumbnails = document.querySelectorAll(
    ".p-color-variation-swiper__thumbnail"
  );
  thumbnails.forEach((thumb, index) => {
    const info = slideInfo[index];
    if (info) {
      thumb.setAttribute("aria-controls", info.slideId);
      /* We'd like to aria-label here, too.  But it is overridden by Swiper. */
    }
  });

  /* Init thumbnail slider without any slide actions. */
  const thumbnailSwiper = createSwiper(
    ".p-color-variation-swiper__thumbnails",
    {
      modules: [],
      slidesPerView: "auto",
      spaceBetween: 10,
      allowTouchMove: false,
      allowSlideNext: false,
      allowSlidePrev: false,
      watchSlidesProgress: true,
      a11y: {
        enabled: true,
        slideRole: "tab",
      },
    }
  );
  const allThumbnails = document.querySelectorAll(
    ".p-color-variation-swiper__thumbnail"
  );

  const mainSwiper = createSwiper(".p-color-variation-swiper__sliders", {
    modules: [Navigation, Pagination, Thumbs, Keyboard],
    thumbs: {
      swiper: thumbnailSwiper,
    },
    navigation: DEFAULT_NAVIGATION,
    pagination: DEFAULT_PAGINATION,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      enabled: true,
      containerRole: "region",
      containerRoleDescriptionMessage: "carousel",
      itemRoleDescriptionMessage: "slide",
      slideRole: "group",
    },
    on: {
      slideChange: function () {
        /* thumbnail requires aria-selected (not only aria-current) */
        allThumbnails.forEach((thumb, index) => {
          thumb.setAttribute(
            "aria-selected",
            index === this.activeIndex ? "true" : "false"
          );
        });
      },
      init: function () {
        /* thumbnail requires aria-selected (not only aria-current) */
        allThumbnails.forEach((thumb, index) => {
          thumb.setAttribute(
            "aria-selected",
            index === this.activeIndex ? "true" : "false"
          );
        });
      },
    },
  });
}

function loadMoreFeaturedProducts() {
  if ($(".featured-products-container").length) {
    $(".featured-products-container .load-more-wrap .load-more-button").on(
      "click",
      function () {
        let container = $(this).closest(".featured-products-container");
        let pageSize = parseInt($(this).data("page-size"));
        let products = $(container).find(
          ".products-grid .card-product.initially-hidden"
        );

        if ($(products).length && pageSize) {
          $(products).each((index, item) => {
            if (index + 1 <= pageSize) {
              $(item).removeClass("initially-hidden");
            }
          });

          if ($(products).length < pageSize) {
            $(container).find(".load-more-wrap").remove();
          }
        }
      }
    );
  }
}

function initToasterModesSlider() {
  $(".toaster-modes-slider").each(function (index, item) {
    var toasterModesSlider = createSwiper(item, {
      modules: [Navigation],
      spaceBetween: 0,
      slidesPerView: "auto",
      // centeredSlides: true,
      loop: true,
      breakpoints: {
        [BREAKPOINT_MD]: {
          slidesPerView: 2.5,
          // spaceBetween: 40,
        },
      },
      navigation: DEFAULT_NAVIGATION,
    });
  });
}
